export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5645.ef8d0a69.jpg";